<script lang="ts">
  interface ListeningIdentity {
    contrarian_pct: number | null;
    early_adopter_pct: number | null;
    genre_breadth: number | null;
    taste_consistency_pct: number | null;
    listening_depth: number | null;
    sufficient_data: boolean;
  }

  let { identity }: { identity: ListeningIdentity | null } = $props();

  const metrics = $derived(
    identity?.sufficient_data
      ? [
          {
            label: 'Contrarian Score',
            value: identity!.contrarian_pct!,
            desc: 'How often they vote against the crowd',
          },
          {
            label: 'Early Adopter',
            value: identity!.early_adopter_pct!,
            desc: 'How quickly they vote when duels open',
          },
          { label: 'Genre Explorer', value: identity!.genre_breadth!, desc: 'How many genres explored' },
          { label: 'Taste Consistency', value: identity!.taste_consistency_pct!, desc: 'How often top picks win' },
          { label: 'Listening Depth', value: identity!.listening_depth!, desc: 'Listen-to-vote ratio' },
        ]
      : [],
  );
</script>

{#if metrics.length > 0}
  <div class="identity-section">
    <h2>Listening Identity</h2>
    <div class="identity-metrics">
      {#each metrics as metric}
        <div class="identity-metric">
          <div class="identity-header">
            <span class="identity-label">{metric.label}</span>
            <span class="identity-value">{metric.value}%</span>
          </div>
          <div class="identity-bar">
            <div class="identity-bar-fill" style="width: {metric.value}%"></div>
          </div>
          <span class="identity-desc">{metric.desc}</span>
        </div>
      {/each}
    </div>
  </div>
{/if}

<style>
  .identity-section {
    margin-top: 2rem;
  }
  .identity-section h2 {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }
  .identity-metrics {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .identity-metric {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 0.75rem 1rem;
  }
  .identity-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.375rem;
  }
  .identity-label {
    font-size: 0.8rem;
    font-weight: 600;
  }
  .identity-value {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--cyan);
  }
  .identity-bar {
    height: 6px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 3px;
    overflow: hidden;
  }
  .identity-bar-fill {
    height: 100%;
    border-radius: 3px;
    background: linear-gradient(90deg, var(--cyan), var(--purple));
    transition: width 0.4s ease;
  }
  .identity-desc {
    font-size: 0.7rem;
    color: var(--text-muted);
    margin-top: 0.25rem;
    display: block;
  }
</style>
